module.exports = __webpack_public_path__ + "static/media/cloud-snow.22ef32a7.svg";